module.exports = __webpack_public_path__ + "static/media/trofeo2.55af79bf.png";